(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const watched = new Set();
  const visible = new WeakSet();
  const pending = new Map();

  function update(element) {
    const active = visible.has(element) && !document.hidden && !reducedMotion.matches;
    if (element.matches('#inv2-root .blob')) {
      element.style.animationPlayState = active ? 'running' : 'paused';
      return;
    }
    if (!active) {
      element.pause();
      return;
    }
    if (element.hasAttribute('data-car-background-video')) {
      if (!element.getAttribute('src')) {
        element.src = element.dataset.src;
        element.load();
      }
      element.play().catch(() => {});
    }
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) visible.add(target);
      else visible.delete(target);
      update(target);
    });
  }, { threshold: 0.05 });

  function observeMedia(root = document) {
    root.querySelectorAll('video.car-review-video, video[data-car-background-video], #inv2-root .blob').forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      if (element.matches('#inv2-root .blob')) element.style.animationPlayState = 'paused';
      if (element.hasAttribute('data-car-background-video')) {
        element.addEventListener('pointerdown', () => {
          if (!element.getAttribute('src')) {
            element.src = element.dataset.src;
            element.load();
          }
        }, { once: true });
      }
      observer.observe(element);
    });
  }

  function whenVisible(selector, initialize) {
    const root = document.querySelector(selector);
    if (!root || pending.has(root)) return;
    const lazyObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      lazyObserver.disconnect();
      pending.delete(root);
      if (root.isConnected) initialize();
    }, { rootMargin: '300px' });
    pending.set(root, lazyObserver);
    lazyObserver.observe(root);
  }

  function updateAll() {
    watched.forEach(element => {
      if (element.isConnected) update(element);
      else {
        observer.unobserve(element);
        watched.delete(element);
      }
    });
  }

  window.CarPerformance = { observeMedia, whenVisible };
  observeMedia();
  document.addEventListener('visibilitychange', updateAll);
  reducedMotion.addEventListener('change', updateAll);
  document.addEventListener('shopify:section:load', event => observeMedia(event.target));
  document.addEventListener('shopify:section:unload', event => {
    watched.forEach(element => {
      if (!event.target.contains(element)) return;
      if (element.tagName === 'VIDEO') element.pause();
      observer.unobserve(element);
      watched.delete(element);
    });
    pending.forEach((lazyObserver, root) => {
      if (!event.target.contains(root)) return;
      lazyObserver.disconnect();
      pending.delete(root);
    });
  });
})();
